module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/sarah-posner-b1bee92fa4f50b1c00a9dc203313d488.jpg";